export const SET_STATISTICS = 'SET_STATISTICS';

export const STATISTICS_INIT_STATE = {

};
